import { render, staticRenderFns } from "./PatientsMemosDataTable.vue?vue&type=template&id=8a5f5070"
import script from "./PatientsMemosDataTable.vue?vue&type=script&lang=js"
export * from "./PatientsMemosDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports